import React from 'react';
import styles from '../styles.module.scss';

interface FlatBtnProps {
    text: string;
    value: number;
    onClicked: (value: number) => void;
}
const FlatBtn: React.FC<FlatBtnProps> = (props) => {
    const moduleName = 'flatBtn';
    const { text, value, onClicked } = props;

    return (
        <div
            className={styles[`${moduleName}`]}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => {
                onClicked(value);
            }}
        >
            <span className={styles[`${moduleName}_text`]} onMouseDown={(e) => e.preventDefault()}>
                {text}
            </span>
        </div>
    );
};

export default FlatBtn;
